import type { AddressPatch, ClientPatch, OrderPatch } from '@/generated/graphql-types';

const mapUpdates = <TInput extends Record<string, unknown>>(
  updates: TInput | undefined,
  fieldMap: Record<string, string>
) => {
  if (!updates) return {};

  return Object.entries(fieldMap).reduce<Record<string, unknown>>((acc, [sourceKey, targetKey]) => {
    const value = (updates as Record<string, unknown>)[sourceKey];
    if (value !== undefined) {
      acc[targetKey] = value;
    }
    return acc;
  }, {});
};

const ORDER_PATCH_FIELDS: Record<string, string> = {
  driverID: 'driverId',
  driverId: 'driverId',
  statusName: 'statusName',
  reasonRefusal: 'refuseReason',
  refuseReason: 'refuseReason',
  plannedDate: 'plannedDate',
  plannedDateDuration: 'plannedDateDuration',
  departmentId: 'departmentId',
  paymentType: 'paymentType',
};

const CLIENT_PATCH_FIELDS: Record<string, string> = {
  fullname: 'fullname',
  phone: 'phone',
};

const ADDRESS_PATCH_FIELDS: Record<string, string> = {
  city: 'city',
  country: 'country',
  district: 'district',
  street: 'street',
  comments: 'comments',
  lat: 'lat',
  lng: 'lng',
};

export const mapOrderUpdates = (updates?: OrderPatch) => mapUpdates(updates, ORDER_PATCH_FIELDS);
export const mapClientUpdates = (updates?: ClientPatch) => mapUpdates(updates, CLIENT_PATCH_FIELDS);
export const mapAddressUpdates = (updates?: AddressPatch) =>
  mapUpdates(updates, ADDRESS_PATCH_FIELDS);
